import React from 'react';
import { Icon } from './Icon.js';
export const IconAdjustContrastFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1ZM2.5,9c0-3.33,2.519-6.08,5.75-6.453V15.453c-3.231-.374-5.75-3.123-5.75-6.453Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconAdjustContrastFill18.js.map